import { httpClient } from "../utils";

export const registerService = {
  register
};

function register(payload) {
  return httpClient.callApi("POST", `/request`, payload);
}
